import styled from 'styled-components';

/**
 * A styled-component is used as the Portal component instead of a primitive `<div/>` so that
 * we can create CSS rules that only apply to descendance of the Portal
 */
const PortalComponent = styled('div')``;

export default PortalComponent;
